import api from './api';
import { ApiResponse } from '../types';
import { LetterCategory, LetterCategoryFormData } from '../types/letters';

const listLetterCategories = async (params?: { includeInactive?: boolean }): Promise<LetterCategory[]> => {
  const search = new URLSearchParams();
  if (params?.includeInactive) search.append('includeInactive', 'true');
  const res = await api.get<ApiResponse<LetterCategory[]>>(`/letter-categories?${search.toString()}`);
  if (!res.data.success) throw new Error(res.data.message);
  return res.data.data || [];
};

const createLetterCategory = async (payload: LetterCategoryFormData): Promise<LetterCategory> => {
  const res = await api.post<ApiResponse<LetterCategory>>('/letter-categories', payload);
  if (!res.data.success) throw new Error(res.data.message);
  return res.data.data!;
};

const updateLetterCategory = async (id: string, payload: Partial<LetterCategoryFormData>): Promise<LetterCategory> => {
  const res = await api.put<ApiResponse<LetterCategory>>(`/letter-categories/${id}`, payload);
  if (!res.data.success) throw new Error(res.data.message);
  return res.data.data!;
};

const deleteLetterCategory = async (id: string): Promise<void> => {
  const res = await api.delete<ApiResponse<LetterCategory>>(`/letter-categories/${id}`);
  if (!res.data.success) throw new Error(res.data.message);
};

const letterCategoryService = {
  listLetterCategories,
  createLetterCategory,
  updateLetterCategory,
  deleteLetterCategory
};

export default letterCategoryService;
